import { getStatisticsFields } from '@/data/generators/statisticsFieldsData';
import { filterByGameLocationsAndResults } from '@/utils/playsFiltering';
import { getPlayerTableData } from '@/utils/playerTableData';
import { commonValues, goalkeeperValues } from '@/data/statisticsFieldsValues';
import playerStatsPlayIndexes from '@/data/player/playerStatsPlayIndexes';

const state = {
  basePlaysStack: [],
  lastFilterValues: null,
};

const mutations = {
  updatePlaysStack(state, playsStack) {
    state.basePlaysStack = playsStack;
  },
};

const getters = {
  getBasePlaysStack: state => state.basePlaysStack,
  filteredPlaysStack(state, getters, rootState, rootGetters) {
    return filterByGameLocationsAndResults(
      state.basePlaysStack,
      rootGetters['filterGeneral/getPlayingAs'],
      rootGetters['filterGeneral/getResults'],
      rootGetters['filterGeneral/getSelectedGamesIds'],
      playerStatsPlayIndexes(),
      rootGetters['teamsGeneral/team'].team_id,
    );
  },
  fieldStatistics(state, getters, rootState, rootGetters) {
    return getStatisticsFields(
      getters.filteredPlaysStack,
      rootGetters['filterGeneral/getSections'],
      rootGetters['playersGeneral/player'].position_id === 1 ? goalkeeperValues : commonValues,
      playerStatsPlayIndexes(),
    );
  },
  tableData(state, getters, rootState, rootGetters) {
    if (!rootGetters['playersGeneral/player'].position_id) {
      return [];
    }
    return getPlayerTableData(
      1,
      rootGetters['playersGeneral/player'].position_id === 1,
      getters.filteredPlaysStack,
      rootGetters['leagueGeneral/filteredPlaysStack'],
      rootGetters['filterGeneral/getSections'],
      rootGetters['filterGeneral/getGamesPlayed'],
    );
  },
  topFiveCategories() {
    return [
      {
        name: 'participación en goles',
        rank: 1,
        total: 44,
        max: 'owner',
      },
      {
        name: 'cabeceo área rival',
        rank: 2,
        total: 13,
        max: 20,
      },
      {
        name: 'tiros a gol',
        rank: 3,
        total: 20,
        max: 26,
      },
      {
        name: '1 vs 1 ofensivo exitoso',
        rank: 4,
        total: 22,
        max: 32,
      },
      {
        name: 'asistencias',
        rank: 4,
        total: 2,
        max: 4,
      },
    ];
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
};
